import axios from "../../lib/axios";
import { IFilter } from "../../types/filters.types";
import checkIsLocalhost from "../../utils/checkIsLocalhost";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "/";

export const getDCResearchData = (
  field: string,
  filters: IFilter,
): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getUnifiedDcResearchValues(MViewInput: {DCDivision: ${filters.warehouseDivision}, RetailDivision: ${filters.retailDivision}, DistributionCenter: ${filters.distribution}, Warehouse: ${filters.warehouse}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}, CIC: "${filters.cic}"})
    {
      ${field}
      errors{ errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/mview`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw
  );
};
